import React, { Component } from 'react';
import { connect } from 'react-redux';
import CodexForm from './CodexForm';
import { authSelector, codexSelector } from '../redux/selectors';
import {hasGroup} from "../common/permissions";
import { Redirect } from 'react-router-dom';
import { fetchCodex, createCodex } from '../redux/actions';

class CodexCreate extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        document.title = "Addiction | Codex | New Page";
        this.props.getCodex();
    }

    handleSubmit(values) {
        this.props.createCodex(values)
    }

    render() {
        if (hasGroup('Member', this.props.auth.groups)) {
            return (
                <div>
                    <h1>Create New Page</h1>
                    <div className="panel-adt">
                        <CodexForm onSubmit={this.handleSubmit} auth={this.props.auth} errors={this.props.errors} codex={this.props.codex} initialValues={{parent: "None", order: 0}} />
                    </div>
                </div>
            )
        } else {
            return (
                <Redirect to="/" />
            )
        }
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    codex: codexSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getCodex: () => dispatch(fetchCodex()),
    createCodex: (values) => dispatch(createCodex(values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CodexCreate);


// WEBPACK FOOTER //
// ./src/Media/CodexCreate.js